import React, { ReactElement } from 'react';
import { LayoutScreenConfig, ScreenType } from '../../config/FlowTypes';
import { ScreenWrapper } from '../styles/Containers';
import { NavigationProps } from './FlowNavigation';
import { SocialProofLayout, SocialProofLayoutConfig } from './layouts/SocialProofLayout';

export type SocialProofScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.SocialProof,
  SocialProofLayoutConfig,
  ScreenNames
>;

type Props<ScreenNames extends string> = NavigationProps<
  SocialProofScreenConfig<ScreenNames>,
  ScreenNames
>;

export const SocialProofScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => (
  <ScreenWrapper>
    <SocialProofLayout
      onPressPrimaryButton={() => props.navigation.next(props)}
      {...props.layout}
    />
  </ScreenWrapper>
);
